(function () {
  'use strict';

  var BUTTON_ID = 'fb-custom-close';

  function getCloseButton() {
    return document.getElementById(BUTTON_ID);
  }

  function makeCloseButton() {
    if (getCloseButton()) return;

    var button = document.createElement('button');

    button.id = BUTTON_ID;
    button.type = 'button';
    button.innerHTML = '&times;';
    button.setAttribute('aria-label', 'Close image gallery');
    button.style.display = 'none';

    document.body.appendChild(button);

    button.addEventListener('click', function () {
      closeProductLightbox();
    });
  }

  function closeProductLightbox() {
    var closed = false;

    /*
     * Fancybox v4 and newer.
     */
    if (
      window.Fancybox &&
      typeof window.Fancybox.close === 'function'
    ) {
      try {
        window.Fancybox.close();
        closed = true;
      } catch (error) {
        console.warn('Fancybox close error:', error);
      }
    }

    /*
     * Fancybox jQuery versions.
     */
    if (
      !closed &&
      window.jQuery &&
      window.jQuery.fancybox &&
      typeof window.jQuery.fancybox.close === 'function'
    ) {
      try {
        window.jQuery.fancybox.close();
        closed = true;
      } catch (error) {
        console.warn('jQuery Fancybox close error:', error);
      }
    }

    /*
     * Theme, Fancybox and PhotoSwipe native buttons.
     */
    if (!closed) {
      var nativeCloseButton = document.querySelector(
        '.fancybox__button--close, ' +
        '.fancybox-button--close, ' +
        '[data-fancybox-close], ' +
        '.pswp__button--close, ' +
        '.modal__close, ' +
        '.modal-close, ' +
        '[data-modal-close], ' +
        '.js-gallery-modal .close'
      );

      if (
        nativeCloseButton &&
        nativeCloseButton.id !== BUTTON_ID
      ) {
        nativeCloseButton.click();
        closed = true;
      }
    }

    /*
     * Final fallback: trigger Escape.
     */
    if (!closed) {
      var escapeEvent = new KeyboardEvent('keydown', {
        key: 'Escape',
        code: 'Escape',
        keyCode: 27,
        which: 27,
        bubbles: true
      });

      document.dispatchEvent(escapeEvent);
      window.dispatchEvent(escapeEvent);
    }

    hideCloseButton();

    /*
     * Check again after the lightbox closes.
     */
    setTimeout(updateCloseButtonVisibility, 100);
    setTimeout(updateCloseButtonVisibility, 300);
  }

  function showCloseButton() {
    var button = getCloseButton();

    if (button && button.style.display !== 'flex') {
      button.style.display = 'flex';
    }
  }

  function hideCloseButton() {
    var button = getCloseButton();

    if (button && button.style.display !== 'none') {
      button.style.display = 'none';
    }
  }

  function elementIsVisible(element) {
    if (!element) return false;

    var styles = window.getComputedStyle(element);

    if (
      styles.display === 'none' ||
      styles.visibility === 'hidden' ||
      styles.opacity === '0'
    ) {
      return false;
    }

    if (element.getAttribute('aria-hidden') === 'true') {
      return false;
    }

    return true;
  }

  function isProductLightboxOpen() {
    /*
     * Lightbox classes applied to the body.
     */
    var body = document.body;

    if (
      body.classList.contains('fancybox-active') ||
      body.classList.contains('fancybox-lock') ||
      body.classList.contains('pswp--open') ||
      body.classList.contains('modal-open')
    ) {
      return true;
    }

    /*
     * Fancybox, PhotoSwipe and theme modal containers.
     */
    var lightboxElements = document.querySelectorAll(
      '.fancybox__container, ' +
      '.fancybox-container, ' +
      '.fancybox-overlay, ' +
      '.pswp--open, ' +
      '.pswp.pswp--visible, ' +
      '.modal.is-active, ' +
      '.modal.is-open, ' +
      '.js-gallery-modal.is-open, ' +
      '.js-gallery-modal.active'
    );

    for (var i = 0; i < lightboxElements.length; i++) {
      if (elementIsVisible(lightboxElements[i])) {
        return true;
      }
    }

    return false;
  }

  function updateCloseButtonVisibility() {
    if (isProductLightboxOpen()) {
      makeCloseButton();
      showCloseButton();
    } else {
      hideCloseButton();
    }
  }

  function scheduleVisibilityChecks() {
    updateCloseButtonVisibility();

    setTimeout(updateCloseButtonVisibility, 50);
    setTimeout(updateCloseButtonVisibility, 150);
    setTimeout(updateCloseButtonVisibility, 300);
    setTimeout(updateCloseButtonVisibility, 600);
  }

  function initializeProductLightboxCloseButton() {
    makeCloseButton();
    updateCloseButtonVisibility();

    var observer = new MutationObserver(function () {
      updateCloseButtonVisibility();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        'class',
        'style',
        'aria-hidden',
        'aria-modal'
      ]
    });

    /*
     * Product images may open their lightbox asynchronously.
     */
    document.addEventListener(
      'click',
      function (event) {
        var imageTrigger = event.target.closest(
          '.product_gallery a, ' +
          '.product_gallery img, ' +
          '.product__images a, ' +
          '.product__images img, ' +
          '[data-fancybox], ' +
          '[data-lightbox], ' +
          '[data-gallery]'
        );

        if (imageTrigger) {
          scheduleVisibilityChecks();
        }
      },
      true
    );

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        setTimeout(updateCloseButtonVisibility, 100);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeProductLightboxCloseButton
    );
  } else {
    initializeProductLightboxCloseButton();
  }
})();